module.exports = __webpack_public_path__ + "media/04.1ee905c6.mp3";